import { Box, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { EventRevisionDto } from "../../../../autogen/bff-api";

interface Props {
  revisions: EventRevisionDto[];
}

const formatInstant = (iso: string): string =>
  new Date(iso).toLocaleString("nb-NO", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Oslo",
  });

export const ChangeLogList = ({ revisions }: Props) => {
  const { t } = useTranslation();
  const newestFirst = [...revisions].sort((a, b) =>
    (b.publishedAt ?? b.createdAt).localeCompare(a.publishedAt ?? a.createdAt),
  );

  return (
    <Stack spacing="3">
      {newestFirst.map((revision) => (
        <Box key={revision.id} borderWidth="1px" borderColor="smBorder" borderRadius="md" p="4">
          <Text fontSize="xs" color="smMuted">
            {revision.publishedAt ? formatInstant(revision.publishedAt) : ""}
          </Text>
          <Text fontSize="sm" fontWeight="medium" mt="1">
            {revision.changeDescription}
          </Text>
          {revision.bidSubmissionDeadline && (
            <Text fontSize="sm" color="smMuted" mt="1">
              {t("Bid deadline")}: {formatInstant(revision.bidSubmissionDeadline)}
            </Text>
          )}
        </Box>
      ))}
    </Stack>
  );
};
